<div class="relative">
  @if (visible && showBackdrop) {
    <button
      type="button"
      class="fixed inset-0 z-30 border-0 bg-black/40 p-0 md:hidden"
      aria-label="Zavřít panel"
      (click)="closeSidebar()"
    ></button>
  }

  <div
    class="fixed top-0 right-0 z-40 h-full w-full border-l border-border bg-card text-card-foreground shadow-lg transition-transform duration-300 ease-in-out md:w-auto"
    [style.width]="visible ? width : '0'"
    [style.maxWidth]="'100vw'"
    [class.translate-x-0]="visible"
    [class.translate-x-full]="!visible"
  >
    <div
      class="flex h-full flex-col"
      [style.width]="width"
      [style.maxWidth]="'100vw'"
    >
      <div
        class="flex flex-shrink-0 items-center border-b border-border p-4"
        [class.justify-between]="showCloseButton"
        [class.justify-start]="!showCloseButton"
      >
        <ng-content select="[sidebar-header]"></ng-content>
        @if (showCloseButton) {
          <button
            type="button"
            class="ml-auto rounded-md p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            aria-label="Zavřít panel"
            title="Zavřít panel"
            (click)="closeSidebar()"
          >
            <i class="ri-close-line text-xl"></i>
          </button>
        }
      </div>

      <div
        class="min-h-0 flex-1"
        [class.overflow-y-auto]="bodyScrollable"
        [class.overflow-hidden]="!bodyScrollable"
        [class.flex]="!bodyScrollable"
        [class.flex-col]="!bodyScrollable"
      >
        <ng-content></ng-content>
        <ng-content select="[sidebar-body]"></ng-content>
      </div>

      <div class="flex-shrink-0 border-t border-border p-4">
        <ng-content select="[sidebar-footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
